export var SsoJoinStatus;
(function (SsoJoinStatus) {
    SsoJoinStatus["UNAVAILABLE"] = "Unavailable";
    SsoJoinStatus["ALLOWED"] = "Allowed";
})(SsoJoinStatus || (SsoJoinStatus = {}));
